import { FC, ReactNode } from 'react'

import { PageType } from '@/components/entities/requests/model/types'
import { CommentsCounter } from '@/components/entities/requests/ui/RequestDetails/Content/CommentsCounter'

interface Props {
  pageType: PageType
  onClick: () => void
  icon: ReactNode
  text: string
  badge?: number
  dataTestId?: string
}

const ContentButton: FC<Props> = ({
  pageType,
  onClick,
  icon,
  text,
  badge,
  dataTestId
}) => (
  <button
    data-testid={dataTestId}
    className="grid w-full grid-rows-[24px_1fr] justify-items-center gap-12 rounded-16 bg-grey-10 p-16 text-center"
    onClick={onClick}
  >
    <div className="relative">
      {icon}
      {badge !== undefined && badge > 0 && (
        <CommentsCounter
          pageType={pageType}
          unreadCount={badge}
          className="absolute -top-4 left-16"
        />
      )}
    </div>
    <span className="flex items-start text-grey-100 text-16">{text}</span>
  </button>
)

export { ContentButton }
